export default __webpack_public_path__ + "static/media/logo-name.9a45f033.svg";